module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('transition', {
    attrs: {
      "name": "mu-dialog-slide"
    },
    on: {
      "after-enter": function($event) {
        _vm.show()
      },
      "after-leave": function($event) {
        _vm.hide()
      }
    }
  }, [(_vm.open) ? _c('div', {
    ref: "popup",
    staticClass: "mu-dialog-wrapper",
    style: ({
      'z-index': _vm.zIndex
    }),
    on: {
      "click": _vm.handleWrapperClick
    }
  }, [_c('div', {
    ref: "dialog",
    staticClass: "mu-dialog",
    class: _vm.dialogClass
  }, [(_vm.showTitle) ? _c('h3', {
    ref: "title",
    staticClass: "mu-dialog-title",
    class: _vm.headerClass
  }, [_vm._t("title", [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mu-dialog-body ",
    class: _vm.bodyClass,
    style: (_vm.bodyStyle)
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    ref: "footer",
    staticClass: "mu-dialog-actions",
    class: _vm.footerClass
  }, [_vm._t("actions")], 2) : _vm._e()])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4db1ef49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/dialog/dialog.vue
// module id = 442
// module chunks = 1